import { render, staticRenderFns } from "./showImg2.vue?vue&type=template&id=9a5d79de&scoped=true"
import script from "./showImg2.vue?vue&type=script&lang=js"
export * from "./showImg2.vue?vue&type=script&lang=js"
import style0 from "./showImg2.vue?vue&type=style&index=0&id=9a5d79de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5d79de",
  null
  
)

export default component.exports